



















































































































































































































































































































































































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import config from '@/config/index';
import CabeceraTabla from '@/reusable/Grid/CabeceraTabla.vue';
import { ServicioProxy } from '../../config/enums';
import {
  emitFormChangeEvent,
  FormErrors,
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { CalendarioNuevoForm } from '@/pantallas/Calendarios/Calendario';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import CampoUnico, { uniqueFieldRule } from '@/reusable/Form/CampoUnico.vue';
import { TipoFrecuenciasCalendario } from '@/config/enums';
import { AxiosVue } from '../../AxiosVue';
import moment from 'moment';

@Component({
  components: {
    FormFieldsContainer,
    CabeceraTabla,
    DatePicker,
    CampoUnico,
  },
})
export default class CalendarioForm extends Vue {
  @Prop() calendarioSeleccionado: CalendarioNuevoForm;
  @Prop({ default: false }) isVerDetalle: boolean;
  @Prop({ default: true }) mostrarActivo: boolean;

  isFormValid: boolean = false;
  mensajeEstado: string = '';
  fechaMinimaInicio: moment.Moment = moment();
  fechaMaximaInicio: moment.Moment = null;
  fechaMinimaFin: moment.Moment = moment();

  uniqueFieldRule = uniqueFieldRule;
  formFields: FormFieldDefMap = {
    activo: {
      label: 'Activo',
      id: 'activo',
      value: 'false',
    },
    nombreCalendario: {
      label: 'Nombre',
      id: 'nombreCalendario',
      value: '',
    },
    frecuenciaSeleccionada: {
      label: 'Frecuencia',
      id: 'frecuencia',
      value: 0,
    },
    diariaCantidadDiasRadio: {
      label: 'Cantidad de Días Radio',
      id: 'diariaCantidadDiasRadio',
      value: 0,
    },
    diariaNumDias: {
      label: 'Número de Días',
      id: 'diariaNumDias',
      value: '',
    },
    semanalCantidadSemanas: {
      label: 'Número de Semanas a Repetir',
      id: 'semanalCantidadSemanas',
      value: '',
    },
    semanalDiasSemana: {
      label: 'Días Semana',
      id: 'semanalDiasSemana',
      value: [],
    },
    mensualRadio: {
      label: '',
      id: 'mensualRadio',
      value: 0,
    },
    mensualDiaMes: {
      label: 'Día del Mes',
      id: 'mensualDiaMes',
      value: '',
    },
    mensualCantMeses: {
      label: 'Número de Meses',
      id: 'mensualCantMeses',
      value: '',
    },
    mensualDiaSemanaNum: {
      label: 'Dia semana',
      id: 'mensualDiaSemanaNum',
      value: '',
    },
    mensualDiaSemanaNombre: {
      label: 'Día semana nombre',
      id: 'mensualDiaSemanaNombre',
      value: '',
    },
    mensualNumMeses: {
      label: 'Cantidad Meses',
      id: 'mensualNumMeses',
      value: '',
    },
    anualCantAnios: {
      label: 'Número de Años a Repetir',
      id: 'anualCantAnios',
      value: '',
    },
    anualNumDiaMes: {
      label: 'Día del mes a Repetir',
      id: 'anualNumDiaMes',
      value: '',
    },
    anualCantMeses: {
      label: 'Número de Meses a Repetir',
      id: 'anualCantMeses',
      value: '',
    },
    fechaInicio: {
      label: 'Fecha Inicio',
      id: 'fechaInicio',
      value: '',
    },
    radioFechaFin: {
      label: 'Fecha Fin',
      id: 'radioFechaFin',
      value: 0,
    },
    fechaFin: {
      label: 'Fecha Fin',
      id: 'fechaFin',
      value: '',
    },
    numRepeticiones: {
      label: 'Número de Repeticiones',
      id: 'numRepeticiones',
      value: '',
    },
  };

  /* data */
  frecuenciaSeleccionada: TipoFrecuenciasCalendario =
    TipoFrecuenciasCalendario.Diaria;
  diaSemanaPosicion: any = [
    { id: 1, posicion: 'Primer' },
    { id: 2, posicion: 'Segundo' },
    { id: 3, posicion: 'Tercer' },
    { id: 4, posicion: 'Cuarto' },
    { id: 5, posicion: 'Quinto' },
  ];
  diaSemanaNombre: any = [
    { id: 1, nombre: 'Lunes' },
    { id: 2, nombre: 'Martes' },
    { id: 3, nombre: 'Miércoles' },
    { id: 4, nombre: 'Jueves' },
    { id: 5, nombre: 'Viernes' },
    { id: 6, nombre: 'Sábado' },
    { id: 7, nombre: 'Domingo' },
  ];
  diasMes: number[] = Array.from({ length: 31 }, (v, k) => k + 1);
  semanasAnio: number[] = Array.from({ length: 52 }, (v, k) => k + 1);
  mesesAnio: number[] = Array.from({ length: 12 }, (v, k) => k + 1);
  anios: number[] = Array.from({ length: 100 }, (v, k) => k + 1);

  totalAsociados: number = 0;

  /* handle */

  @Watch('calendarioSeleccionado', { deep: true })
  handleCalendarioSeleccionadaChange() {
    if (!this.calendarioSeleccionado) {
      this.frecuenciaSeleccionada = TipoFrecuenciasCalendario.Diaria;
      this.fechaMinimaInicio = moment();
      this.fechaMinimaFin = moment();
      this.totalAsociados = 0;
      return;
    }
    const dateFormat = 'YYYY-MM-DD';
    this.formFields.nombreCalendario.value = this.calendarioSeleccionado.nombreCalendario;
    this.formFields.activo.value = this.calendarioSeleccionado.estado;
    this.formFields.frecuenciaSeleccionada.value = this.calendarioSeleccionado.frecuenciaSeleccionada;
    this.formFields.diariaCantidadDiasRadio.value = this.calendarioSeleccionado
      .diariaCantidadDiasRadio
      ? this.calendarioSeleccionado.diariaCantidadDiasRadio
      : 0;
    this.formFields.diariaNumDias.value = this.calendarioSeleccionado.diariaNumDias;
    this.formFields.semanalCantidadSemanas.value = this.calendarioSeleccionado.semanalCantidadSemanas;
    this.formFields.semanalDiasSemana.value = this.calendarioSeleccionado
      .semanalDiasSemana
      ? this.calendarioSeleccionado.semanalDiasSemana
      : [];
    this.formFields.mensualRadio.value = this.calendarioSeleccionado
      .mensualRadio
      ? this.calendarioSeleccionado.mensualRadio
      : 0;
    this.formFields.mensualDiaMes.value = this.calendarioSeleccionado.mensualDiaMes;
    this.formFields.mensualCantMeses.value = this.calendarioSeleccionado.mensualCantMeses;
    this.formFields.mensualDiaSemanaNum.value = this.calendarioSeleccionado.mensualDiaSemanaNum;
    this.formFields.mensualDiaSemanaNombre.value = this.calendarioSeleccionado.mensualDiaSemanaNombre;
    this.formFields.mensualDiaSemanaNombre.value = this.calendarioSeleccionado.mensualDiaSemanaNombre;
    this.formFields.mensualNumMeses.value = this.calendarioSeleccionado.mensualNumMeses;
    this.formFields.anualCantAnios.value = this.calendarioSeleccionado.anualCantAnios;
    this.formFields.anualNumDiaMes.value = this.calendarioSeleccionado.anualNumDiaMes;
    this.formFields.anualCantMeses.value = this.calendarioSeleccionado.anualCantMeses;
    this.formFields.fechaInicio.value = this.calendarioSeleccionado.fechaInicio;
    this.formFields.radioFechaFin.value = this.calendarioSeleccionado.radioFechaFin;
    this.formFields.fechaFin.value = this.calendarioSeleccionado.fechaFin;
    this.formFields.numRepeticiones.value = this.calendarioSeleccionado.numRepeticiones;
    this.totalAsociados = this.calendarioSeleccionado.totalAsociados;
    this.cambioEstadoSwitch(this.formFields.activo.value);
  }

  @Watch('$validator.errors.items.length')
  handleErrorsChange() {
    this.emitFormChange();
  }

  @Watch('formFields', { deep: true })
  handleFormChange() {
    this.emitFormChange();

    if (this.calendarioSeleccionado) {
      return;
    }
    this.fechaMinimaFin = this.formFields.fechaInicio.value as moment.Moment;

    // FIXME corregir
    this.fechaMinimaFin = moment(this.formFields.fechaInicio.value.toString());
    this.fechaMaximaInicio =
      moment(this.formFields.fechaFin.value.toString()) !== moment()
        ? moment(this.formFields.fechaFin.value.toString())
        : moment();
  }

  emitFormChange() {
    emitFormChangeEvent(
      this.$emit.bind(this),
      {
        entity: {
          nombreCalendario: this.formFields.nombreCalendario.value,
          estado: this.formFields.activo.value,
          frecuenciaSeleccionada: this.formFields.frecuenciaSeleccionada.value,
          diariaCantidadDiasRadio: this.formFields.diariaCantidadDiasRadio
            .value,
          diariaNumDias: this.formFields.diariaNumDias.value,
          semanalCantidadSemanas: this.formFields.semanalCantidadSemanas.value,
          semanalDiasSemana: this.formFields.semanalDiasSemana.value,
          mensualRadio: this.formFields.mensualRadio.value,
          mensualDiaMes: this.formFields.mensualDiaMes.value,
          mensualCantMeses: this.formFields.mensualCantMeses.value,
          mensualDiaSemanaNum: this.formFields.mensualDiaSemanaNum.value,
          mensualDiaSemanaNombre: this.formFields.mensualDiaSemanaNombre.value,
          mensualNumMeses: this.formFields.mensualNumMeses.value,
          anualCantAnios: this.formFields.anualCantAnios.value,
          anualNumDiaMes: this.formFields.anualNumDiaMes.value,
          anualCantMeses: this.formFields.anualCantMeses.value,
          fechaInicio: this.formFields.fechaInicio.value,
          radioFechaFin: this.formFields.radioFechaFin.value,
          fechaFin: this.formFields.fechaFin.value,
          numRepeticiones: this.formFields.numRepeticiones.value,
        } as CalendarioNuevoForm,
      },
      this
    );
  }

  validarNombreCalendario(nombre: string) {
    const axios = new AxiosVue(ServicioProxy.Calendario);
    const id =
      this.calendarioSeleccionado === undefined
        ? 0
        : this.calendarioSeleccionado.id;
    return axios.http.get(
      `Calendario/ChequearNombreUnico/${id}/${nombre}/${config.getClienteSesion()}`
    );
  }

  cambioEstadoSwitch(isActivo: boolean) {
    this.fields[this.formFields.activo.id].dirty = true;
    this.handleFormChange();
    if (isActivo) {
      this.mensajeEstado = '';
      this.formFields.activo.label = 'Activo';
    } else {
      if (this.totalAsociados === 0) {
        this.mensajeEstado =
          'Al dejar como inactivo, no se podrán realizar asociaciones.';
      }
      this.formFields.activo.label = 'Inactivo';
    }
    this.$emit('estadoSwitch', isActivo);
  }

  handleFrecuenciaSeleccionada() {
    if (this.formFields.frecuenciaSeleccionada.value === 3) {
      if (this.formFields.radioFechaFin.value == 1) {
        this.formFields.radioFechaFin.value = 2;
      }
    }
  }

  mounted() {
    const validator = makeValidatorDictionary(this.formFields);
    validator.custom.numRepeticiones.min_value =
      'Numero de repeticiones debe ser mayor a 0 y menor a 1000.';
    validator.custom.numRepeticiones.max_value =
      'Numero de repeticiones debe ser mayor a 0 y menor a 1000.';
    this.$validator.localize('es', validator);
    this.handleFormChange();
    this.handleCalendarioSeleccionadaChange();
  }
}
